<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="text-center">
        <!-- 404 Illustration -->
        <div class="mx-auto h-32 w-32 text-primary-600">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-full h-full">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8a7.962 7.962 0 01-2 5.291z" />
          </svg>
        </div>
        
        <!-- Error Message -->
        <div class="mt-8">
          <h1 class="text-6xl font-bold text-gray-900">404</h1>
          <h2 class="mt-4 text-2xl font-semibold text-gray-700">Página no encontrada</h2>
          <p class="mt-2 text-gray-500 max-w-md mx-auto">
            Lo sentimos, la página que estás buscando no existe o ha sido movida.
          </p>
        </div>
        
        <!-- Actions -->
        <div class="mt-8 space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
          <router-link 
            to="/" 
            class="btn btn-primary inline-flex items-center"
          >
            <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Ir al Dashboard
          </router-link>
          
          <button 
            @click="goBack" 
            class="btn btn-secondary inline-flex items-center"
          >
            <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Volver atrás
          </button>
        </div>
        
        <!-- Help Links -->
        <div class="mt-12">
          <p class="text-sm text-gray-500 mb-4">¿Necesitas ayuda?</p>
          <div class="flex justify-center space-x-6 text-sm">
            <a href="#" class="text-primary-600 hover:text-primary-500">
              Centro de ayuda
            </a>
            <a href="#" class="text-primary-600 hover:text-primary-500">
              Contactar soporte
            </a>
            <a href="#" class="text-primary-600 hover:text-primary-500">
              Reportar problema
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'NotFound',
  setup() {
    const router = useRouter()
    
    const goBack = () => {
      if (window.history.length > 1) {
        router.go(-1)
      } else {
        router.push('/')
      }
    }
    
    return {
      goBack
    }
  }
}
</script>